import PropTypes from 'prop-types'
import Container from '@material-ui/core/Container'
import Hero from '@components/hero-new/hero'
import PageBreakCta from '@components/page-break-cta/index'
import MarketingFormEmbed from '@components/marketing-form-embed/index'
import defaults from '@config/defaults'
import { NextSeo } from 'next-seo'
import { RenderRichText } from '@components/renderers/index'
import useStyles from './reregister.styles'

const ReRegister = (props) => {
  const {
    metaDataField,
    metaImage,
    metaDescription,
    promptBlockSection,
    heroImage,
    heroImageMobile,
    headline,
    subtitle,
    breadcrumbsCollection,
    ctaLinkText,
    ctaLink,
    bodyRichText,
    marketingEmailForm,
  } = props

  const styles = useStyles()

  const heroProps = {
    image: heroImage,
    imageMobile: heroImageMobile,
    ctaText: ctaLinkText,
    summary: subtitle,
    externalLink: ctaLink,
    headline,
    breadcrumbs: breadcrumbsCollection?.items,
  }

  return (
    <div className={styles.root}>
      <NextSeo
        noindex={defaults.noindexNofollow}
        nofollow={defaults.noindexNofollow}
        title={metaDataField}
        description={metaDescription}
        canonical={`${defaults.baseUrl}workingolf/reregister`}
        openGraph={{
          title: metaDataField,
          description: metaDescription,
          type: 'website',
          url: `${defaults.baseUrl}workingolf/reregister`,
          images: [{ url: metaImage && metaImage.url }],
        }}
      />
      <Hero
        hero={heroProps}
      />
      <Container className={styles.textWrapper}>
        <RenderRichText {...bodyRichText} />
      </Container>
      <PageBreakCta {...promptBlockSection} />
      <MarketingFormEmbed {...marketingEmailForm} />
    </div>
  )
}

ReRegister.propTypes = {
  metaDataField: PropTypes.string,
  metaImage: PropTypes.object,
  metaDescription: PropTypes.string,
  photoSpotlight: PropTypes.object,
  promptBlockSection: PropTypes.object,
  listCardAccordionSection: PropTypes.object,
  testimonialsSection: PropTypes.object,
  nextStepsHeadline: PropTypes.string,
  nextStepsDescription: PropTypes.string,
  nextStepsCardsCollection: PropTypes.object,
  heroImage: PropTypes.object,
  heroImageMobile: PropTypes.object,
  headline: PropTypes.string,
  subtitle: PropTypes.string,
  breadcrumbsCollection: PropTypes.object,
  ctaLinkText: PropTypes.string,
  ctaLink: PropTypes.string,
  bodyRichText: PropTypes.object,
  marketingEmailForm: PropTypes.object,
}

ReRegister.defaultProps = {}

export default ReRegister
